import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PageCTA } from '../components/PageCTA';
import { ChevronDown } from 'lucide-react';
export function FAQPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const faqs = [{
    question: '¿Esto es solo diseño o incluye estrategia?',
    answer: 'Incluye ambas. Un diseño bonito sin estrategia no vende. Analizamos tu negocio, definimos la mejor estructura para convertir visitas en clientes y luego aplicamos un diseño premium que transmita confianza. Cada botón, texto y sección tiene un propósito específico en el embudo de conversión.'
  }, {
    question: '¿Cuánto tiempo tarda el proceso completo?',
    answer: 'El tiempo medio de desarrollo es de 2 a 4 semanas, dependiendo de la complejidad del proyecto y la rapidez con la que nos proporciones el material necesario (textos, imágenes, logo). Proyectos más sencillos o urgentes pueden estar listos en 10 días laborables si hay buena coordinación.'
  }, {
    question: '¿Qué necesito proporcionar para empezar?',
    answer: 'Básicamente, información sobre tu negocio: qué haces, a quién te diriges, qué te diferencia de la competencia. Si tienes logo, fotos profesionales y textos, perfecto. Si no los tienes, no te preocupes; podemos orientarte, usar recursos de stock premium o incluir estos servicios como parte del proyecto.'
  }, {
    question: '¿Podré actualizar mi web yo mismo?',
    answer: 'Sí, absolutamente. Entregamos el sistema con un panel autogestionable muy intuitivo. Podrás cambiar textos, subir nuevas imágenes, publicar artículos o actualizar tu menú/catálogo sin depender de nosotros, sin pagar cuotas extra y sin necesidad de saber absolutamente nada de código.'
  }, {
    question: '¿Está optimizado para móvil?',
    answer: "El 80% de tus clientes te buscarán desde su teléfono. Por eso diseñamos primero para móvil (Mobile First), asegurando que la experiencia sea rápida, fluida y perfecta en cualquier pantalla. No es solo que 'se vea bien', es que sea fácil navegar y comprar desde un smartphone."
  }, {
    question: '¿Incluye la configuración de redes sociales?',
    answer: 'Sí, es una parte fundamental de nuestro ecosistema. Configuramos tus perfiles profesionales, creamos una imagen de marca coherente con tu nueva web y dejamos todo conectado para que el tráfico fluya de forma natural entre tus redes sociales y tu página principal.'
  }, {
    question: '¿Ofrecéis mantenimiento posterior?',
    answer: 'Sí. Una vez entregado el proyecto, la web es 100% tuya. Sin embargo, ofrecemos planes opcionales de soporte técnico y mantenimiento para que tu presencia digital siga funcionando perfectamente, esté siempre actualizada y segura, y puedas pedirnos ajustes cuando tu negocio evolucione.'
  }, {
    question: '¿Puedo contratar solo uno de los servicios?',
    answer: 'Nuestro enfoque es integral porque creemos firmemente que los mejores resultados se consiguen cuando todo está conectado en un ecosistema. Sin embargo, entendemos que cada negocio está en una fase diferente. Podemos adaptar el paquete a tus necesidades específicas tras una primera conversación de diagnóstico.'
  }, {
    question: '¿Para qué tipo de negocio sirve?',
    answer: 'Nuestro sistema es ideal para negocios locales (restaurantes, clínicas, peluquerías, tiendas), empresas de servicios B2B/B2C y marcas personales que necesitan profesionalizar su imagen, destacar frente a su competencia local y captar clientes online de forma recurrente y predecible.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="pt-24 bg-[#0a0a0a] min-h-screen" data-id="element-474">
      {/* Page Header */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-475">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl text-center" data-id="element-476">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-477">
            <h1 className="text-4xl md:text-5xl font-medium text-white mb-6 tracking-tight" data-id="element-478">
              Preguntas Frecuentes
            </h1>
            <p className="text-lg text-gray-400 leading-relaxed font-normal max-w-2xl mx-auto" data-id="element-479">
              Resolvemos todas tus dudas sobre nuestro proceso, metodología y
              resultados antes de empezar a trabajar juntos.
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-480">
        <div className="container mx-auto px-6 md:px-12 max-w-3xl" data-id="element-481">
          <div className="card-premium !overflow-hidden divide-y divide-white/[0.05]" data-id="element-482">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={index} className="group" data-id="element-483">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-[#131313] transition-colors" data-id="element-484">
                    <span className={`font-medium text-[15px] transition-colors ${isOpen ? 'text-brand-emerald' : 'text-gray-200 group-hover:text-white'}`} data-id="element-485">
                      {faq.question}
                    </span>
                    <ChevronDown size={18} className={`shrink-0 transition-transform duration-300 ${isOpen ? 'text-brand-emerald rotate-180' : 'text-gray-500 group-hover:text-gray-400'}`} data-id="element-486" />
                  </button>
                  <AnimatePresence data-id="element-487">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-488">
                        <div className="px-6 pb-6 text-gray-400 text-sm leading-relaxed" data-id="element-489">
                          {faq.answer}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>

      {/* About Growthly */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-490">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl" data-id="element-491">
          <div className="mb-12 text-center" data-id="element-492">
            <h2 className="text-3xl font-medium text-white mb-4 tracking-tight" data-id="element-493">
              Sobre Growthly
            </h2>
          </div>

          <div className="card-premium p-8 md:p-12 text-center" data-id="element-494">
            <p className="text-gray-400 text-base leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-495">
              En Growthly creemos que todo negocio, sin importar su tamaño,
              merece una presencia digital que refleje su verdadero valor. Vemos
              a diario excelentes profesionales y negocios locales perder
              clientes simplemente porque su imagen en internet no transmite la
              calidad real de su trabajo.
            </p>
            <p className="text-gray-400 text-base leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-496">
              Nacimos con el objetivo de democratizar el acceso a ecosistemas
              digitales premium. No somos una agencia tradicional que te vende
              una web y desaparece. Somos tu socio tecnológico estratégico.
            </p>
            <div className="inline-block p-6 bg-white/[0.03] border border-white/[0.05] rounded-xl max-w-2xl mx-auto" data-id="element-497">
              <p className="text-white font-medium text-lg leading-relaxed" data-id="element-498">
                "Nuestra visión es clara: transformar negocios tradicionales en
                máquinas digitales eficientes, preparadas para competir y ganar
                en la economía actual."
              </p>
            </div>
          </div>
        </div>
      </section>

      <PageCTA data-id="element-499" />
    </div>;
}